var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.areaChartOptions && _vm.series)?_c('div',{staticClass:"chart_card"},[_c('h5',{staticClass:"chart_title m-0"},[_vm._t("chart_title")],2),_c('apexchart',{attrs:{"type":"area","height":_vm.ChartHeigh,"options":_vm.areaChartOptions,"series":_vm.series}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }